module.exports = __webpack_public_path__ + "img/DR.4a1f4e17.png";